import React, { FunctionComponent, useState } from "react";
import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { trimName } from "/src/domain/shared/trimName";
import { sec2hms } from "/src/utils/time-utils";
import { CupRecord } from "/src/domain/challenges/ChallengeRatingCup";
import { CurrentUserArrow, ParticipantArrow } from "/src/ui/shared/challengeProtocol/Arrow";
import { ChallengeUser } from "/src/domain/challenges/ChallengeUser";
import ChallengeButton from "/src/ui/challengeProtocol/ChallengeButton";
import cs from "classnames";
import { theme } from "/src/assets/theme";
import { useTranslation } from "react-i18next";

export type CupParticipantProps = {
    record: CupRecord,
    currentUser?: ChallengeUser,
    isExpanded: boolean
}

export const CupParticipant: FunctionComponent<CupParticipantProps> = ({ record, currentUser, isExpanded }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Grid
            container
            component={ChallengeButton}
            className={cs(classes.container, { [classes.currentUser]: currentUser?.id === record.participant.id })}
            alignItems="center"

        >
            <Grid
                item container xs={11} spacing={1}>
                <Grid item container xs={1} className={classes.cell}>
                    {
                        (currentUser?.id !== record.participant.id) ?
                            <ParticipantArrow
                                rotate={isExpanded}
                            />
                            : <CurrentUserArrow
                                rotate={isExpanded}
                            />
                    }

                </Grid>
                <Grid item xs={1} style={{ padding: '0.2rem 0' }} className={classes.cell}>
                    {record.place}
                </Grid>
                <Grid item xs={6} className={classes.cell}>
                    {trimName(record.participant.firstName, record.participant.lastName)}
                </Grid>
                <Grid item container xs={4} justifyContent="flex-end" className={classes.cell}>
                    {sec2hms(record.time)}
                </Grid>
            </Grid>
            <Grid item container xs={11} spacing={1}>
                <Grid item xs={2}></Grid>
                <Grid item xs={10} container direction="column" className={classes.info}>
                    {record.participant.coach &&
                        <Grid item><b>{`${t('trainer')}: `}</b> {record.participant.coach}</Grid>}
                    {record.participant.city &&
                        <Grid item>{record.participant.city}</Grid>}
                </Grid>
            </Grid>
        </Grid>
    );
}

const useStyles = makeStyles((muiTheme) => ({
    cell: {
        overflowX: 'hidden',
    },
    container: {
        width: '100%',
        margin: 0,
        fontSize: '0.9rem',
        fontWeight: 500,
        padding: '0.5rem 0',
    },
    currentUser: {
        backgroundColor: theme.primaryCurrentUserColor
    },
    info: {
        marginTop: '0.2rem',
        fontSize: '0.75rem',
        '&>div': {
            padding: '0.2rem 0',
        }
    }
}));